<template id="bs-modal-asset-view">
<div class="modal fade" id="assetViewModal" tabindex="-1" role="dialog" aria-labelledby="assetViewModal">
<div class="modal-dialog modal-lg" role="document">

	<div v-if="!data_loaded" class="modal-content" style="min-height:200px">
		<img class="center-me" src="/images/loading-color.svg">
	</div>

	<div v-else class="modal-content">
		<div class="text-gray-500 font-weight-bold text-uppercase text-base bg-gray-100 px-35 py-25 rounded-top border-bottom">
			Details for {{ asset.name }}
			<button type="button" class="close" data-dismiss="modal" aria-label="Close">
	        	<span aria-hidden="true">&times;</span>
	        </button>
		</div>	

		<div class="row no-gutters">
		<div class="col-md-6 border-right">
			<div class="bg-gray-700 p-35 text-white text-xl font-weight-bold text-center">
				<img :src="asset.thumbnail_url" class="img-fluid">
				<div class="mt-3 text-left">{{ asset.name }}</div>
				<div class="text-left text-gray-500 text-sm font-weight-normal">
					{{ Array.prototype.map.call(asset.asset_types, function(item) { return item.label; }).join(', ') }}
				</div>
			</div>
			<div class="px-35 py-3">
				<div>
					<span v-for="specialty in asset.specialties" class="badge bg-teal-200 text-teal-700 mr-1">{{ specialty.label }}</span>
				</div>
				<div>
					<span v-for="service_line in asset.service_lines" class="badge bg-orange-100 text-orange-700 mr-1">{{ service_line.label }}</span>
				</div>
				<div class="mt-3 text-right">
					<a :href="asset.media_url" class="btn btn-primary" download>Download File</a>
				</div>
			</div>
		</div>

		<div class="col-md-6">
			<div class="px-35 py-25">
				<span class="text-blue-700 font-weight-bold text-lg mr-2">Check-ins</span>
				<span class="badge badge-primary text-lg" v-html="asset.checkins.length" />
			</div>
				
			<ul class="list-group list-group-flush">
				<li v-for="checkin in asset.checkins" class="list-group-item d-flex">
					<div class="rounded-circle circle-cropped avatar-xs mr-2">
						<img class="img-fluid" :src="checkin.checkin_user.photo_url">
					</div>
					<div>						
						<span class="text-sm">{{ checkin.checkin_user.display_name }}</span> 
						<span class="text-sm text-gray-500">{{ moment(checkin.created_at).format('MMM D, YYYY') }}</span>
						<div class="mt-1">{{ checkin.checkin_type.label }} <span class="text-gray-500" @click="closeModal()">with <router-link :to="{ name: 'physicians.show', params: { id: checkin.physician.id } }" class="font-weight-bold">{{ checkin.physician.display_name }}</router-link></span></div>
					</div>
				</li>
			</ul>
		</div>
	</div>

		<div class="d-flex py-2 px-35 bg-gray-100 text-gray-500 text-sm align-items-center rounded-bottom">
			<div class="rounded-circle circle-cropped avatar-sm mr-1">
				<img class="img-fluid" :src="asset.user.photo_url">
			</div>			
			created by {{ asset.user.display_name }}

			<div class="flex-grow-1 text-gray-700 text-right">{{ moment(asset.created_at).format('MMM D, YYYY') }}</div>
		</div>
	</div>
</div>
</div>
</template>

<script>

	export default {
		props: ['asset_id'],

		data() {
			return {
				data_loaded: false,
				asset: null,
			}
		},

		methods: {
			closeModal() {
	    		jQuery('.modal').modal('hide');
	    		jQuery('.modal-backdrop').remove();
	    	},

			fetchAsset(id) {
				this.data_loaded = false;
				axios.get('/api/assets/' + id).then(({data}) => {
					this.asset = data;
					this.data_loaded = true;
				});
			}
		},

		watch: {
			asset_id() {
				this.fetchAsset(this.asset_id);
			}
		}
	}
</script>